/*
**  @desc:    搜狐统计服务中的几种统计方式
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-19
*/

import BaseStat from './base-stat';
import Cookie from '../utils/cookie';

var SohuStat = (function() {
    var base = '//pv.sohu.com/';
    var serviceMap = {
        'pv': 'pv.gif',
        'ev': 'ev.gif',
        'click': 'click.gif',
        'content_ev': 'content_ev.gif',
        'prom_ev': 'prom_ev.gif',
        'prom_pv': 'prom_pv.gif',
        'action': 'action.gif',
        'appAction': 'appAction.gif',
        'appEv':'appEv.gif'
    };
    var SUV = Cookie.get('SUV');

    function sendStatistics(type, params) {
        var baseUrl = base + serviceMap[type];
        params.SUV = SUV;
        BaseStat.sendStatistics(baseUrl, params);
    }

    /*
    ** actionId: 事件id
    ** params: 额外上报的参数对象
    */
    function sendActionStat(actionId, params) {
        actionId = String(actionId);
        var reportObj = {
            // 对于没有新增业务线id的五位事件id，在前面加上事件id（101）
            actionId: actionId.length == 5 ? `101${actionId}` : actionId
        };
        if(params) {
            for(var key in params) {
                reportObj[key] = params[key];
            }
        }
        sendStatistics('action', reportObj);
    }

    return {
        sendStatistics: sendStatistics,
        sendActionStat: sendActionStat
    };
})();

export default SohuStat;